import {
  type AuthorTypeEnum,
  authorTypeArray,
  getAuthorTypeString,
} from '@/entities/authors'
import { HeartOutlined, StopOutlined } from '@ant-design/icons'
import { Card, Col, Radio, Row, Statistic } from 'antd'
import { type CheckboxGroupProps } from 'antd/es/checkbox'
import { type RadioGroupProps } from 'antd/lib'
import { useUnit } from 'effector-react'

import {
  $authorType,
  $isLoadingInitially,
  $totalData,
  authorTypeChanged,
} from '../../model/statistics-authors-data.model'
import { AuthorsStatisticsTable } from '../AuthorsStatisticsTable'
import styles from './styles.module.scss'

export function AuthorsStatistics() {
  const loading = useUnit($isLoadingInitially)

  const totalData = useUnit($totalData)
  const authorType = useUnit($authorType)
  const changeAuthorType = useUnit(authorTypeChanged)
  const options: CheckboxGroupProps<AuthorTypeEnum>['options'] =
    authorTypeArray.map((type) => ({
      label: getAuthorTypeString(type),
      value: type,
    }))
  const onChange: RadioGroupProps['onChange'] = (event) => {
    const value = event.target.value
    changeAuthorType(value)
  }

  const stats = [
    {
      title: 'Нравится',
      value: totalData?.totalLikesCount,
      icon: <HeartOutlined />,
    },
    {
      title: 'Не нравится',
      value: totalData?.totalDislikesCount,
      icon: <StopOutlined />,
    },
  ]

  return (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <Radio.Group
          block
          options={options}
          optionType="button"
          value={authorType}
          onChange={onChange}
        />
      </Col>
      <Col span={24}>
        <Row gutter={[16, 16]}>
          {stats.map((item) => (
            <Col xs={24} sm={12} key={item.title}>
              <Card variant="borderless" className={styles.statisticsCard}>
                <Statistic
                  loading={loading}
                  title={item.title}
                  value={item.value}
                  prefix={item.icon}
                />
              </Card>
            </Col>
          ))}
        </Row>
      </Col>
      <Col span={24}>
        <AuthorsStatisticsTable />
      </Col>
    </Row>
  )
}
